import React from "react";
import { useAppSelector } from "../lib/hook";
import { Navigate, Outlet } from "react-router-dom";

interface AuthContextProps {
  // Add props here
}

const AuthContext: React.FC<AuthContextProps> = () => {
  const isLogin = useAppSelector((store) => store?.userAuth?.data);
  return !isLogin ? (
    <Navigate replace={false} to="/auth/login" />
  ) : (
    <>
      <Outlet />
    </>
  );
};

export default AuthContext;
